import { AnimatedDiv } from '@vimily/bonjoro-ui-components-v2/AnimatedDiv';
import React from 'react';
import cx from 'classnames';
import { openRedeemCouponModal } from '../RedeemCouponModal';
import { useFeatures } from '~/react-hooks/use-features';

export interface RedeemCouponCtaProps {
  show?: boolean;
}

export function RedeeemCouponCta({ show = false }: RedeemCouponCtaProps) {
  const { acceptsDiscounts } = useFeatures();

  if (!acceptsDiscounts) return null;

  return (
    <AnimatedDiv
      show={show}
      className={cx([
        'text-base underline cursor-pointer',
        'leading-3 hover:v2-text-neutral-500 v2-text-neutral-500',
      ])}
      onClick={() => openRedeemCouponModal()}
    >
      I have a coupon code!
    </AnimatedDiv>
  );
}
